import Swiper, { Pagination, Navigation } from 'swiper';
Swiper.use([Pagination, Navigation]);

const sliderBorder = document.querySelector('.slider-border');

if (sliderBorder) {
	const sliderWrapper = sliderBorder.querySelector('.swiper-wrapper');
	const lastSliderSlide = sliderBorder.querySelector(
		'.swiper-slide:last-of-type'
	);

	const swiperBorder = new Swiper('.slider-border .swiper', {
		loop: false,
		slidesPerView: 'auto',
		spaceBetween: -8,
		slidesOffsetAfter: sliderWrapper.clientWidth - lastSliderSlide.clientWidth,
		paginationClickable: true,
		breakpoints: {
			569: {
				spaceBetween: -19,
			},
			1025: {
				navigation: {
					nextEl: '[data-slider-next]',
					prevEl: '[data-slider-prev]',
				},
			},
			1440: {
				spaceBetween: -30,
				navigation: {
					nextEl: '[data-slider-next]',
					prevEl: '[data-slider-prev]',
				},
			},
		},

		pagination: {
			el: '.federation__ruc .swiper-pagination',
			type: 'fraction',
			clickable: true,
			formatFractionCurrent: function (number) {
				return number < 10 ? `0${number}` : number;
			},
			formatFractionTotal: function (number) {
				return number < 10 ? `0${number}` : number;
			},
		},

		on: {
			init(swiperBorder) {
				if (swiperBorder.snapGrid.length > swiperBorder.slidesGrid.length) {
					swiperBorder.params.slidesOffsetAfter = 0;
					swiperBorder.update();
				} else {
					swiperBorder.snapGrid[swiperBorder.snapGrid.length - 1] =
						swiperBorder.slidesGrid[swiperBorder.slidesGrid.length - 1];
				}
			},
		},
	});
}
